module.exports = __webpack_public_path__ + "img/d3a9284.png";